// extracted by mini-css-extract-plugin
export default {"bgColor":"PaymentPolicy_bgColor__Swju5","title":"PaymentPolicy_title__fHNFA","termsContent":"PaymentPolicy_termsContent__o0LA3"};